import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { POE_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function PoeAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="Poe Alternative — Every Major Model, One App"
      description="A Poe alternative with GPT, Claude, Gemini, and Arya in one private workspace — plus images, video, music, and an API."
      canonical="/poe-alternative"
      keywords="Poe alternative, alternative to Poe, Poe AI alternative, better than Poe, Poe competitor, apps like Poe, sites like Poe, free Poe alternative, best Poe alternative"
      page={POE_ALTERNATIVE}
    />
  );
}
